module.exports = __webpack_public_path__ + "static/media/jelena-mladenovic.436b09cc.jpg";